export default __webpack_public_path__ + "static/media/18-100.ed1bfcaa.jpg";